// extracted by mini-css-extract-plugin
export default {"select-label":"Select_select-label__RNnw3","select":"Select_select__im11k","is-error":"Select_is-error__L2b7R","select-error":"Select_select-error__9bac1"};